module.exports = "/lucky-balls/img/drum/drum_loop_036.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_036.png
// module id = 1051
// module chunks = 0